import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setBreadcrumb } from "../stores/actions/config.actions";

type BreadcrumbItem = {
  name: string;
  pathName: string | null;
};

export const useBreadCrumb = (items: BreadcrumbItem[]) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const breadcrumbItems = items.map((items) => ({
      name: items.name,
      pathName: items.pathName,
    }));

    dispatch(setBreadcrumb(breadcrumbItems));
  }, []);
};
